<template>
  <div id="oversea-agent" class="section" style="height: auto;padding: 20px 20px 10px 20px">
    <div class="inner-row">
      <el-form :disabled="!isEdit" :inline="true" label-width="132px" label-position="left">
        <el-form-item :label="$t('Partners.forecastReceivingEmail')">
          <el-input v-model="form.forcastAddress" no="forcastAddress" style="width: 300px" />
        </el-form-item>
      </el-form>
    </div>
    <div style="display: flex">
      <div class="section form-column">
        <el-form :disabled="!isEdit" :inline="true" label-width="132px" label-position="left">
          <span class="title">{{ $t('Partners.oceanBillOfLadingAddress') }}</span>
          <div style="display: flex">
            <div class="section form-column">
              <span>{{ $t('CargoMsg.Cargo_Consignee') }}</span>
              <el-form-item
                v-for="count in 7"
                :key="'blAddressLine'+count"
              >
                <el-input
                  :ref="'blAddressLine'+count"
                  v-model="form['blAddressLine'+count]"
                  :no="'blAddressLine'+count"
                  :filter-chars="false"
                  style="width:300px"
                  @dblclick.native="showBlAddressDialog"
                  @change="()=>wrapAddr(form,'blAddressLine'+count,count+1 > 7 ? null :'blAddressLine'+(count+1),maxChars)"
                />
              </el-form-item>
            </div>
            <div class="section form-column">
              <span>{{ $t('CargoMsg.Cargo_NotifyParty') }}</span>
              <el-form-item
                v-for="count in 7"
                :key="'blNotifyAddressLine'+count"
              >
                <el-input
                  :ref="'blNotifyAddressLine'+count"
                  v-model="form['blNotifyAddressLine'+count]"
                  :no="'blNotifyAddressLine'+count"
                  :filter-chars="false"
                  style="width:300px"
                  @dblclick.native="showBlNotifyAddressDialog"
                  @change="()=>wrapAddr(form,'blNotifyAddressLine'+count,count+1 > 7 ? null :'blNotifyAddressLine'+(count+1),maxChars)"
                />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="section form-column">
        <el-form :disabled="!isEdit" :inline="true" label-width="132px" label-position="left">
          <span class="title">{{ $t('Partners.airBillOfLadingAddress') }}</span>
          <div style="display: flex">
            <div class="section form-column">
              <span>{{ $t('CargoMsg.Cargo_Consignee') }}</span>
              <el-form-item
                v-for="count in 7"
                :key="'airAddressLine'+count"
              >
                <el-input
                  :ref="'airAddressLine'+count"
                  v-model="form['airAddressLine'+count]"
                  :no="'airAddressLine'+count"
                  :filter-chars="false"
                  style="width:300px"
                  @dblclick.native="showAirAddressDialog"
                  @change="()=>wrapAddr(form,'airAddressLine'+count,count+1 > 7 ? null :'airAddressLine'+(count+1),maxChars)"
                />
              </el-form-item>
            </div>
            <div class="section form-column">
              <span>{{ $t('CargoMsg.Cargo_NotifyParty') }}</span>
              <el-form-item
                v-for="count in 7"
                :key="'airNotifyAddressLine'+count"
              >
                <el-input
                  :ref="'airNotifyAddressLine'+count"
                  v-model="form['airNotifyAddressLine'+count]"
                  :no="'airNotifyAddressLine'+count"
                  :filter-chars="false"
                  style="width:300px"
                  @dblclick.native="showAirNotifyAddressDialog"
                  @change="()=>wrapAddr(form,'airNotifyAddressLine'+count,count+1 > 7 ? null :'airNotifyAddressLine'+(count+1),maxChars)"
                />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="box">
      <span class="title">{{ $t('Partners.theCorrespondingServiceOverseaAgent') }}</span>
      <div class="triggers" style="margin-bottom: 10px;">
        <el-button
          no="new"
          :disabled="!isEdit"
          type="primary"
          @click="showEditDialog(true)"
        >{{ $t('common.btn.new') }}</el-button>
        <el-button
          no="edit"
          :disabled="!isEdit"
          type="primary"
          @click="showEditDialog(false)"
        >{{ $t('common.btn.edit') }}</el-button>
        <el-button
          no="delete"
          :disabled="!isEdit"
          type="danger"
          @click="remove"
        >{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="grid-wrapper" style="flex-grow: 1">
      <cargo-ag-grid
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="height: 100%"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('Payment.businessType')">
            <el-select v-model="editDialog.form.lob" no="lob">
              <el-option
                v-for="(item,index) in lobSource"
                :key="index"
                :label="isZh ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Tool.User')">
            <cargo-user-select
              no="overseaOp"
              :method-params="{category: 'role',shape: 'overseaOp'}"
              :default-value="editDialog.form.userId||''"
              style="width:190px;"
              @change="selectCargoItem"
            />
          </el-form-item>
          <el-form-item :label="$t('Partners.isDefault')">
            <el-radio-group v-model="editDialog.form.defaultUser" no="defaultUser">
              <el-radio no="yes" :label="true">{{ $t('Message.Yes') }}</el-radio>
              <el-radio no="no" :label="false">{{ $t('Message.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('Payment.remarks')">
            <el-input v-model="editDialog.form.remarks" no="remarks" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="saveSub">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :disabled="readonly"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" no="confirm" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="close"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getOverseaAgentUserList } from '@/api/partner/overseaAgentUser'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { AutoIncrementNum } from '@/utils/commonUtil'
import cargoInput from '@/components/Cargo/Common/cargoInput.vue'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea.vue'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'OverseaAgentForm',
  components: { CargoRichTextarea, cargoInput, cargoAdvanceSelect, cargoUserSelect },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedRow: null,
      lobSource: [],
      lobMap: new Map(),
      selectTypeNames: TYPE_NAMES,
      form: {},
      filter: {
        overseaAgentUuid: ''
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: p => { this.selectedRow = p.data }
      },
      columnDefs: [
        {
          headerName: this.$t('Payment.businessType'),
          field: 'lob',
          width: 200,
          cellRenderer: params => {
            return this.lobMap.get(params.value)
          }
        }, {
          headerName: this.$t('Tool.User'),
          field: 'userId',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('Partners.isDefault'),
          field: 'defaultUser',
          width: 200,
          cellRenderer: params => {
            return params.value ? this.$t('Message.Yes') : this.$t('Message.No')
          }
        }, {
          headerName: this.$t('Payment.remarks'),
          field: 'remarks',
          width: 200
        }
      ],
      rowData: [],
      deletedOverseaAgentUserKeys: [],
      editDialog: {
        visible: false,
        title: '',
        form: {}
      },
      autoIncrementNum: new AutoIncrementNum(),
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0, autoUppercase: false, autoHalfWord: false
        }
      },
      maxChars: 255
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    },
    readonly() {
      return !this.isEdit
    },
    isZh() {
      return this.$i18n.locale === 'zh'
    }
  },
  created() {
    this.lobSource = [{ code: 'ALL', chineseName: '全部', englishName: 'ALL' }, ...SystemConstants.FBA_LOBS]
    for (const item of this.lobSource) {
      this.lobMap.set(item.code, this.isZh ? item.chineseName : item.englishName)
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (isRefresh) {
        this.form = row.overseaAgentDetail
        if (this.form.uuid) {
          this.filter.overseaAgentUuid = this.form.uuid
          this.toQuery()
          this.form['blAddressLine' + 1] = this.form.blAddress
        } else {
          this.rowData = []
        }
        this.deletedOverseaAgentUserKeys = []
      }
    },
    getSubmitData() {
      this.form.overseaAgentUsers = this.rowData
      this.form.deletedOverseaAgentUserKeys = this.deletedOverseaAgentUserKeys
      this.form.blAddress = this.form['blAddressLine' + 1]
      return {
        overseaAgentDetail: this.form
      }
    },
    toQuery() {
      const filter = this.filter
      getOverseaAgentUserList(filter).then(res => {
        res.data.list.forEach(p => {
          p.seq = this.autoIncrementNum.getNextNum()
        })
        this.rowData = res.data.list
      })
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          roleType: 5,
          lob: 'ALL',
          userId: '',
          defaultUser: false,
          remarks: '',
          overseaAgentUuid: this.form.uuid,
          seq: this.autoIncrementNum.getNextNum()
        }
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const rows = this.selectedRow
        if (!rows) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    selectCargoItem(item) {
      this.editDialog.form.userId = item.value
    },
    async saveSub() {
      const self = this
      const form = self.editDialog.form
      if (!this.checkOverseaAgentUser(form)) return
      const row = this.rowData.find(item => item.seq === form.seq)
      if (row) {
        Object.assign(row, form)
        this.gridApi.refreshCells({ force: true })
      } else {
        this.rowData.push(form)
      }
      self.editDialog.visible = false
    },
    remove() {
      const self = this
      const rows = this.selectedRow
      if (!rows) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const index = this.rowData.findIndex(p => p.seq === rows.seq)
        this.rowData.splice(index, 1)
        if (rows.uuid) {
          this.deletedOverseaAgentUserKeys.push(rows.uuid)
        }
      }).catch(() => { })
    },
    // 验证输入
    checkOverseaAgentUser(form) {
      if (!form.userId) {
        this.$message.warning('用户不能为空!')
        return false
      }
      for (const user of this.rowData) {
        if (user.seq === form.seq) {
          continue
        }
        if (user.userId === form.userId && user.lob === form.lob) {
          this.$message.warning(this.$t('Partners.user') + '【' + ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', form.userId, 'chineseName') + '】' + this.$t('Partners.multipleSameBusinessPosition'))
          return false
        }
      }
      return true
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObj = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0, autoUppercase: false, autoHalfWord: false
      }
      this.advanceTextDialog.formatObj = formatObj ? { ...defaultFormatObj, ...formatObj } : defaultFormatObj
    },
    showBlAddressDialog() {
      this.showAdvanceTextDialog(this.$t('Partners.oceanBillOfLadingAddress'), this.mergeBlAddressLine(), this.splitBlAddressLine, false, {
        maxChar: 255, autoUppercase: true, autoHalfWord: true
      })
    },
    showBlNotifyAddressDialog() {
      this.showAdvanceTextDialog(this.$t('Partners.oceanBillOfLadingAddress'), this.mergeBlNotifyAddressLine(), this.splitBlNotifyAddressLine, false, {
        maxChar: 255, autoUppercase: true, autoHalfWord: true
      })
    },
    showAirAddressDialog() {
      this.showAdvanceTextDialog(this.$t('Partners.airBillOfLadingAddress'), this.mergeAirAddressLine(), this.splitAirAddressLine, false, {
        maxChar: 255, autoUppercase: true, autoHalfWord: true
      })
    },
    showAirNotifyAddressDialog() {
      this.showAdvanceTextDialog(this.$t('Partners.airBillOfLadingAddress'), this.mergeAirNotifyAddressLine(), this.splitAirNotifyAddressLine, false, {
        maxChar: 255, autoUppercase: true, autoHalfWord: true
      })
    },
    splitBlAddressLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['blAddressLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['blAddressLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['blAddressLine' + i] = ''
      }
    },
    splitBlNotifyAddressLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['blNotifyAddressLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['blNotifyAddressLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['blNotifyAddressLine' + i] = ''
      }
    },
    splitAirAddressLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['airAddressLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['airAddressLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['airAddressLine' + i] = ''
      }
    },
    splitAirNotifyAddressLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['airNotifyAddressLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['airNotifyAddressLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['airNotifyAddressLine' + i] = ''
      }
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    mergeBlAddressLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['blAddressLine' + i] || ''
        result += '\n'
      }
      result += (this.form['blAddressLine7'] || '')
      return result.trimEnd()
    },
    mergeBlNotifyAddressLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['blNotifyAddressLine' + i] || ''
        result += '\n'
      }
      result += (this.form['blNotifyAddressLine7'] || '')
      return result.trimEnd()
    },
    mergeAirAddressLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['airAddressLine' + i] || ''
        result += '\n'
      }
      result += (this.form['airAddressLine7'] || '')
      return result.trimEnd()
    },
    mergeAirNotifyAddressLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['airNotifyAddressLine' + i] || ''
        result += '\n'
      }
      result += (this.form['airNotifyAddressLine7'] || '')
      return result.trimEnd()
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    }
  }
}
</script>

<style lang="scss">
#oversea-agent {
  .section.form-column {
    width: auto;
  }
  .box {
    position: relative;
    padding-top: 10px;
    .box-label {
      position: absolute;
      left: 10px;
      top: 0;
      padding: 0 5px;
      border-radius: 3px;
      font-size: 13px;
      line-height: 20px;
      background: #f5f7fa;
      color: #404144;
    }
    .box-content {
      width: 100%;
      border: 1px solid #ababab;
      border-radius: 5px;
      padding: 0;
      padding-top: 10px;
    }
  }
}
</style>
